var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10.5,
  height: 14,
  viewBox: "0 0 10.5 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.75,5.833V3.5a3.5,3.5,0,0,0-7,0V5.833H3V14H13.5V5.833ZM8.833,10.338v1.328H7.667V10.338a1.167,1.167,0,1,1,1.167,0ZM5.917,5.833V3.5a2.333,2.333,0,1,1,4.667,0V5.833Z",
  transform: "translate(-3)",
  fill: "#252525"
})));
export default SvgIconLock;